// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ev-O7","controls":"styles_controls__27rIi","charLimit":"styles_charLimit__1AKtr","input":"styles_input__1iPrj","send":"styles_send___LFhl"};